// extracted by mini-css-extract-plugin
module.exports = {"metaContainer":"Meta_metaContainer__aXXX2","projectTitle":"Meta_projectTitle__2pWs8","tags":"Meta_tags__2p9Qi"};